// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E3OJ","textarea":"styles_textarea__3ksIv"};